<div class="wrapper" [class.mobile]="isMobile()">
  <button class="exit-button noHeader">
    <i
      nz-icon
      [nzType]="'icons:exit'"
      class="svg-icon"
      role="button"
      tabindex="0"
      (keypress)="clickExit.emit()"
      (click)="clickExit.emit()"
    ></i>
  </button>

  <div class="content wideContent mobileBigFooterContent">
    <div class="title-without-icon">
      <h4>{{ i18n.langString("edit_photo") }}</h4>
    </div>

    <div class="image-container">
      <image-cropper
        [imageChangedEvent]="fileEvent()"
        [maintainAspectRatio]="mode() === 'photo'"
        [aspectRatio]="375 / 224"
        [format]="fileType()"
        [autoCrop]="true"
        (imageLoaded)="onImageLoaded()"
        (imageCropped)="onImageCropped($event)"
      ></image-cropper>
    </div>
  </div>
</div>

<!-- Footer for Desktop -->
@if (!isMobile()) {
  <app-footer>
    <div class="footer-inner-wrapper mobileColumnWrapper">
      <app-nav-button
        [svgIcon]="'icons:arrow-left'"
        (clickEvent)="navBack.emit()"
        [darksecondary]="true"
        [smol]="true"
      >
        {{ i18n.langString("go_back") }}
      </app-nav-button>

      <span class="black-text">
        {{
          mode() === "photo"
            ? i18n.langString("confirm_image_crop")
            : i18n.langString("confirm_image_crop_scan")
        }}
      </span>

      @if (mode() === "photo") {
        <app-nav-button
          class="mobileFlex1"
          [svgIcon]="'icons:fixed'"
          (clickEvent)="confirmImageCrop()"
          [primary]="true"
        >
          {{ i18n.langString("save_photo") }}
        </app-nav-button>
      }

      @if (mode() === "scan") {
        <app-nav-button
          class="mobileFlex1"
          [svgIconRight]="'icons:arrow-right'"
          (clickEvent)="confirmImageCrop()"
          [primary]="true"
        >
          {{ i18n.langString("continue") }}
        </app-nav-button>
      }
    </div>
  </app-footer>
}

<!-- Footer for Mobile -->
@if (isMobile()) {
  <app-footer>
    <div class="footer-inner-wrapper mobileColumnWrapper low-padding">
      <span class="black-text">
        {{
          mode() === "photo"
            ? i18n.langString("confirm_image_crop")
            : i18n.langString("confirm_image_crop_scan")
        }}
      </span>
    </div>

    <div class="footer-inner-wrapper mobileColumnWrapper">
      <app-nav-button
        [svgIcon]="'icons:arrow-left'"
        (clickEvent)="navBack.emit()"
        [onlyIcon]="true"
        class="btn-not-wide"
        [smol]="true"
        [darksecondary]="true"
      ></app-nav-button>

      @if (mode() === "photo") {
        <app-nav-button
          class="mobileFlex1"
          [svgIcon]="'icons:fixed'"
          (clickEvent)="confirmImageCrop()"
          [primary]="true"
        >
          {{ i18n.langString("save_photo") }}
        </app-nav-button>
      }

      @if (mode() === "scan") {
        <app-nav-button
          class="mobileFlex1"
          [svgIconRight]="'icons:arrow-right'"
          (clickEvent)="confirmImageCrop()"
          [primary]="true"
        >
          {{ i18n.langString("continue") }}
        </app-nav-button>
      }
    </div>
  </app-footer>
}
